import {Component, OnInit, ViewContainerRef, EventEmitter, Output, Input} from '@angular/core';

import {Questions} from "../classes/question";


import {GetQuestionsFromJson} from "../shared/services/get-questions-from-json";
import {MatDialog} from '@angular/material';
import {Subscription} from "rxjs";
import {BroadcastEventService} from "../shared/services/broadcast.event.service";
import {SettingsOpenService} from "../shared/services/settings-open.service";
import {UserResponse} from "../classes/user-response";
import {BroadcastUserResService} from "../shared/services/broadcast-user-res.service";
import {Response} from "../classes/response";
import {Anomalies} from "../classes/anomaly";
import {BroadcastAnomaliesService} from "../shared/services/broadcast-anomalies.service";
import {CascadingJSONService} from "../shared/services/cascading-json.service";



@Component({
  selector: 'questionnaire-preview',
  templateUrl: './questionnaire-preview.component.html',
  styleUrls: ['./questionnaire-preview.component.css']
})

export class QuestionnairePreviewComponent implements OnInit {

  @Output() showPreview = new EventEmitter<string>();
  @Input() selectedSurveyData;
  @Input() datakeys;
  previewToggleLabel : string = 'Preview';
  //Error message if JSON is not loaded properly
  //Will be replaced later when Json is loaded from broadcasting service
  errorMessage: string;

  //An array to store all the questions
  //will refrence the questions array from broadcasting service later
  questions: Questions[] = [];
  anomalies : Anomalies[];

  showAnomalyRepeater : boolean = false;
  showAnomaly : boolean = false;


  shouldIShowRepeaterDialogBox : string = "";

  simpleAnomalyHeading : string =  "";
  simpleAnomalyMsg :string =  "";
  simpleAnomalyMsg_S :string =  "";
  repeaterAnomalyHeading :string =  "";
  repeaterAnomalyMsg : string = "";
  repeaterAnomalyMsg_S : string = "";
  cascad : any;

  //Two parameters
  //GetQuestionsFromJson gets questions from json file using http
  //Will be replaced later when questions are subscribed from broadcasting service
  //MatDialog is used to open dialog box for repeater questions
  constructor (private getQuestionsFromJson: GetQuestionsFromJson, private broadcastEventService : BroadcastEventService,private settingsOpenService : SettingsOpenService, private userResService : BroadcastUserResService, private anomalyService : BroadcastAnomaliesService,private cascadService : CascadingJSONService) {
    this.subscription = this.broadcastEventService.getQuestions().subscribe(message => {this.questions = message});
    this.subscription = this.settingsOpenService.getSettingsOpen().subscribe(message => {this.settingsOpened(message)});
    this.subscription = this.anomalyService.getAnomalies().subscribe(message => {this.anomalies = message});
    this.subscription = this.cascadService.getCascad().subscribe(message => {this.newCascad(message)});
    //TODO will become complicated once session and user ids gets implemented
    broadcastEventService.setQuestions(JSON.parse(localStorage.getItem("test123")));
  }

  newCascad(mes : any){
    this.cascad = JSON.stringify(mes);
  }

  settingsOpened(result : any){
    if(this.previewToggleLabel === "Close"){
      this.previewToggleLabel = "Preview";
      this.showPreview.emit('');
    }
  }


  repeaterQuestionDeps : Questions[] = [];
  repeaterQuestion : Questions;
  numOfRepeater : number;

  message : Questions[] = [];
  subscription : Subscription;

  //array is a 2d array with each row corresponds to questions of a particular tab
  repeater2dArray : number[] = [];
  indexArray : number[] = [];
  //ToDo: remember that for it work properly all the repeating questions should follow repeater parent in json.
  //ToDo: So when creating the big json this should be made sure that they are following each other if that can't be done then think of a new algo to calculate index of array here
  indexOfRepeater : number;
  i : number = 0;
  tabs : string[] = [];


  ngOnInit() {
    //Calls getQuestions() function when this class gets initiated
    //Is used to load questions array
   //this.getQuestions();


  }

  // ngOnChanges(){

  //   console.log("....",this.selectedSurveyData,this.datakeys);
  //   for (let index = 0; index < this.questions.length; index++) {
  //     console.log("....",this.selectedSurveyData[this.datakeys[index]]);
  //     this.questions[index].user_Res[0] = this.selectedSurveyData[this.datakeys[index]];
  //   }
  //   console.log("....",this.questions);
  // }



  //Get Questions from the service
  //ToDo: Later the implementation will be changed to subscribe to questions array in broadcasting service
  getQuestions() {

    // Standard code to getQuestions array from HTTP service taken from angular.io documentation
    this.getQuestionsFromJson.getQuestions()
      .subscribe(
        questions => this.updateQuestions(questions),
        error =>  this.errorMessage = <any>error);
}

  updateQuestions(result : any){
      this.questions = result;
      // this.userResponse = [];
      // for(let i = 0;i<this.questions.length ; i++){
      //   this.userResponse.push(new UserResponse);
      //   let res = new Response();
      //   res.res = '';
      //   this.userResponse[i].userResponse.push(res);
      // }
  }

  //Function to calculate if current question should be shown
  shouldIShowQuestion(question : Questions) : boolean{



    //If The repeat dependence is not null then question should be shown in repeater dialog box and not here
    //Hence retuning false if repeatDependence if not null
    //Also setting is_Visible property false to mark that current question is not shown
    if(question.Parent_Repeat !== null){
      question.is_Visible = false;
      return false;
    }


    //Checking if current question is option dependent
    //If it is then we need to check if its options criteria is satisfied to decide whether to show it or not
    if(question.Opt_Dep.length > 0){

      //If this questions parent has not received a user response then it will straight a way not shown
      //So it checks if its parent has a user response
      if(this.questions[question.Parent_Dep-1].user_Res[0].length > 0){

        //Looping over all the responses user submitted for this questions parent
        //The criteria should match any one of the response to show this question
        let answers = this.questions[question.Parent_Dep - 1].user_Res[0].split(" ");
        for(let answer of answers){

          if(!isNaN(parseInt(answer))) {
            //Looping over all the options for which to show this question
            for (let option of question.Opt_Dep) {

              //if answer matches this option then will show the question given that it also match the age range criteria
              if (parseInt(answer) === option) {

                //If there is no age range defined for this question then we can show this question
                if (parseInt((question.Age_Range.length).toString())==parseInt('0') && this.questions[question.Parent_Dep - 1].is_Visible) {
                  question.is_Visible = true;
                  return true;
                }
                //This question has a age range defined and hence should check if it is satisfied
                else {

                  //If this question's parents is not visible then this question will also not be shown
                  if (!this.questions[question.Parent_Dep - 1].is_Visible) {
                    question.is_Visible = false;
                    return false;
                  }
                  //If this question's parent is visible then we will have to check the age range
                  else {

                    if (!this.questions[question.Parent_Age - 1].is_Visible || this.questions[question.Parent_Age - 1].user_Res.length === 0) {
                      question.is_Visible = false;
                      return false;
                    }

                    if (parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) >= question.Age_Range[0] && parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) <= question.Age_Range[1]) {
                      question.is_Visible = true;
                      return true;
                    } else {
                      question.is_Visible = false;
                      return false;
                    }


                  }

                }


              }
            }
          }
        }
      }

      //Otherwise the question should not be shown
      question.is_Visible = false;
      return false;
    }

    //General question will be aged checked based on same theory as above
    //Read the comments above
    if(parseInt((question.Age_Range.length).toString())==parseInt('0')){
      question.is_Visible = true;
      return true;
    }
    else {

      if(!this.questions[question.Parent_Age -1].is_Visible){
        question.is_Visible = false;
        return false;

      }else{


        if(!this.questions[question.Parent_Age-1].is_Visible || this.questions[question.Parent_Age - 1].user_Res.length ===0){
          question.is_Visible = false;
          return false;
        }

        if(parseInt(this.questions[question.Parent_Age -1].user_Res[0]) >= question.Age_Range[0] && parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) <= question.Age_Range[1]){
          question.is_Visible = true;
          return true;
        }else{
          question.is_Visible = false;
          return false;
        }

      }

    }

  }

  //Check if the question is a dependent question
  //Event from child components is raised only for dependent questions
  isQuestionDep(question : Questions) : boolean{

    if(question.Qn_Deps.length > 0){
      return true;
    }

    return false;

  }

//Store the value user entered in child components
  userEnteredValue(userRes){



    //It is possible that userRes field does not exist when first  encountered for a question
    //So it instantiate it by inserting one value and poping it later
    //Resulting in creation of an empty array
    // if(!this.questions[parseInt(userRes[1])-1].user_Res){
    //   this.questions[parseInt(userRes[1])-1].user_Res  = [1];
    //   this.questions[parseInt(userRes[1])-1].user_Res.pop();
    // }

      this.questions[parseInt(userRes[1]) -1].user_Res[parseInt(userRes[0])] = userRes[2];
      this.broadcastEventService.setQuestions(this.questions);
      localStorage.setItem("test123",JSON.stringify(this.questions));


      let question_Num  = parseInt(userRes[1]);

      if(this.anomalies) {
        for (let anomaly of this.anomalies) {


          let found: boolean = false;


          if (anomaly.Qn_Num === question_Num) {


            let answers = userRes[2].split(" ");


            if (anomaly.dispValue === 'Simple Anomaly') {

              let rules = anomaly.Rule.split(" ");

              if (this.questions[anomaly.Qn_Num - 1].Qn_Disp_Value === 'Number') {

                if (rules[1] === '<=') {
                  if (parseInt(answers[0]) <= parseInt(rules[2])) {
                    console.log(answers[0] + " " + rules[2]);
                    found = true;
                    if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                      this.showAnomalyRepeater = true;
                      this.repeaterAnomalyHeading = anomaly.Msg_H;
                      this.repeaterAnomalyMsg = anomaly.Msg;
                      this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                    } else {
                      this.showAnomaly = true;
                      this.simpleAnomalyHeading = anomaly.Msg_H;
                      this.simpleAnomalyMsg = anomaly.Msg;
                      this.simpleAnomalyMsg_S = anomaly.Msg_S;
                    }
                  }
                }
                else if (rules[1] === '<') {
                  if (parseInt(answers[0]) < parseInt(rules[2])) {
                    console.log(answers[0] + " " + rules[2]);
                    found = true;
                    if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                      this.showAnomalyRepeater = true;
                      this.repeaterAnomalyHeading = anomaly.Msg_H;
                      this.repeaterAnomalyMsg = anomaly.Msg;
                      this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                    } else {
                      this.showAnomaly = true;
                      this.simpleAnomalyHeading = anomaly.Msg_H;
                      this.simpleAnomalyMsg = anomaly.Msg;
                      this.simpleAnomalyMsg_S = anomaly.Msg_S;
                    }
                  }
                }
                else if (rules[1] === '=') {
                  if (parseInt(answers[0]) === parseInt(rules[2])) {
                    console.log(answers[0] + " " + rules[2]);
                    found = true;
                    if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                      this.showAnomalyRepeater = true;
                      this.repeaterAnomalyHeading = anomaly.Msg_H;
                      this.repeaterAnomalyMsg = anomaly.Msg;
                      this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                    } else {
                      this.showAnomaly = true;
                      this.simpleAnomalyHeading = anomaly.Msg_H;
                      this.simpleAnomalyMsg = anomaly.Msg;
                      this.simpleAnomalyMsg_S = anomaly.Msg_S;
                    }
                  }
                }
                else if (rules[1] === '>') {
                  if (parseInt(answers[0]) > parseInt(rules[2])) {
                    console.log(answers[0] + " " + rules[2]);
                    found = true;
                    if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                      this.showAnomalyRepeater = true;
                      this.repeaterAnomalyHeading = anomaly.Msg_H;
                      this.repeaterAnomalyMsg = anomaly.Msg;
                      this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                    } else {
                      this.showAnomaly = true;
                      this.simpleAnomalyHeading = anomaly.Msg_H;
                      this.simpleAnomalyMsg = anomaly.Msg;
                      this.simpleAnomalyMsg_S = anomaly.Msg_S;
                    }
                  }
                }
                else if (rules[1] === '>=') {
                  if (parseInt(answers[0]) >= parseInt(rules[2])) {
                    console.log(answers[0] + " " + rules[2]);
                    found = true;
                    if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                      this.showAnomalyRepeater = true;
                      this.repeaterAnomalyHeading = anomaly.Msg_H;
                      this.repeaterAnomalyMsg = anomaly.Msg;
                      this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                    } else {
                      this.showAnomaly = true;
                      this.simpleAnomalyHeading = anomaly.Msg_H;
                      this.simpleAnomalyMsg = anomaly.Msg;
                      this.simpleAnomalyMsg_S = anomaly.Msg_S;
                    }
                  }
                }

              } else {

                let ruleAnswers = rules[2].substring(1, rules[2].length - 1).split(",");

                for (let answer of answers) {

                  let foundMatch: boolean = false;

                  if (!isNaN(parseInt(answer))) {

                    for (let ruleAnswer of ruleAnswers) {

                      if (!isNaN(parseInt(ruleAnswer)) && parseInt(ruleAnswer) === parseInt(answer)) {
                        console.log(ruleAnswer + " " + answer);
                        found = true;
                        foundMatch = true;
                        if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                          this.showAnomalyRepeater = true;
                          this.repeaterAnomalyHeading = anomaly.Msg_H;
                          this.repeaterAnomalyMsg = anomaly.Msg;
                          this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                        } else {
                          this.showAnomaly = true;
                          this.simpleAnomalyHeading = anomaly.Msg_H;
                          this.simpleAnomalyMsg = anomaly.Msg;
                          this.simpleAnomalyMsg_S = anomaly.Msg_S;
                        }
                        break;
                      }

                    }

                    if (foundMatch) {
                      break;
                    }

                  }


                }


              }


            } else {

              let rules = anomaly.Rule.split("&");
              let rule1;
              let rule2;
              if (parseInt(rules[0].split(" ")[0]) === question_Num) {
                rule1 = rules[0].trim().split(" ");
                rule2 = rules[1].trim().split(" ");
              } else {
                rule1 = rules[1].trim().split(" ");
                rule2 = rules[0].trim().split(" ");
              }


              let depQuestion = parseInt(rule2[0]);

              let foundForDep: boolean = false;

              for (let userResponse of this.questions[depQuestion - 1].user_Res) {


                if (this.questions[depQuestion - 1].Qn_Disp_Value === 'Number') {


                  if (rule2[1] === '<=') {

                    if (parseInt(userResponse[0]) <= parseInt(rule2[2])) {
                      foundForDep = true;

                    }
                  }
                  else if (rule2[1] === '<') {
                    if (parseInt(userResponse[0]) < parseInt(rule2[2])) {
                      foundForDep = true;

                    }
                  }
                  else if (rule2[1] === '=') {
                    if (parseInt(userResponse[0]) === parseInt(rule2[2])) {
                      foundForDep = true;

                    }
                  }
                  else if (rule2[1] === '>') {
                    if (parseInt(userResponse[0]) > parseInt(rule2[2])) {
                      foundForDep = true;

                    }
                  }
                  else if (rule2[1] === '>=') {
                    if (parseInt(userResponse[0]) >= parseInt(rule2[2])) {
                      foundForDep = true;

                    }
                  }

                } else {

                  let ruleAnswers = rule2[2].substring(1, rule2[2].length - 1).split(",");
                  let answersR = userResponse.split(" ");


                  for (let answer of answersR) {

                    let foundMatch: boolean = false;

                    if (!isNaN(parseInt(answer))) {

                      for (let ruleAnswer of ruleAnswers) {

                        if (!isNaN(parseInt(ruleAnswer)) && parseInt(ruleAnswer) === parseInt(answer)) {
                          foundForDep = true;
                          foundMatch = true;

                          break;
                        }

                      }

                      if (foundMatch) {
                        break;
                      }

                    }


                  }

                }


              }

              if (foundForDep) {


                if (this.questions[anomaly.Qn_Num - 1].Qn_Disp_Value === 'Number') {


                  if (rule1[1] === '<=') {

                    if (parseInt(answers[0]) <= parseInt(rule1[2])) {
                      console.log(answers[0] + " " + rule1[2]);
                      found = true;
                      if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                        this.showAnomalyRepeater = true;
                        this.repeaterAnomalyHeading = anomaly.Msg_H;
                        this.repeaterAnomalyMsg = anomaly.Msg;
                        this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                      } else {
                        this.showAnomaly = true;
                        this.simpleAnomalyHeading = anomaly.Msg_H;
                        this.simpleAnomalyMsg = anomaly.Msg;
                        this.simpleAnomalyMsg_S = anomaly.Msg_S;
                      }
                    }
                  }
                  else if (rule1[1] === '<') {
                    if (parseInt(answers[0]) < parseInt(rule1[2])) {
                      console.log(answers[0] + " " + rule1[2]);
                      found = true;
                      if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                        this.showAnomalyRepeater = true;
                        this.repeaterAnomalyHeading = anomaly.Msg_H;
                        this.repeaterAnomalyMsg = anomaly.Msg;
                        this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                      } else {
                        this.showAnomaly = true;
                        this.simpleAnomalyHeading = anomaly.Msg_H;
                        this.simpleAnomalyMsg = anomaly.Msg;
                        this.simpleAnomalyMsg_S = anomaly.Msg_S;
                      }
                    }
                  }
                  else if (rule1[1] === '=') {
                    if (parseInt(answers[0]) === parseInt(rule1[2])) {
                      console.log(answers[0] + " " + rule1[2]);
                      found = true;
                      if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                        this.showAnomalyRepeater = true;
                        this.repeaterAnomalyHeading = anomaly.Msg_H;
                        this.repeaterAnomalyMsg = anomaly.Msg;
                        this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                      } else {
                        this.showAnomaly = true;
                        this.simpleAnomalyHeading = anomaly.Msg_H;
                        this.simpleAnomalyMsg = anomaly.Msg;
                        this.simpleAnomalyMsg_S = anomaly.Msg_S;
                      }
                    }
                  }
                  else if (rule1[1] === '>') {
                    if (parseInt(answers[0]) > parseInt(rule1[2])) {
                      console.log(answers[0] + " " + rule1[2]);
                      found = true;
                      if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                        this.showAnomalyRepeater = true;
                        this.repeaterAnomalyHeading = anomaly.Msg_H;
                        this.repeaterAnomalyMsg = anomaly.Msg;
                        this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                      } else {
                        this.showAnomaly = true;
                        this.simpleAnomalyHeading = anomaly.Msg_H;
                        this.simpleAnomalyMsg = anomaly.Msg;
                        this.simpleAnomalyMsg_S = anomaly.Msg_S;
                      }
                    }
                  }
                  else if (rule1[1] === '>=') {
                    if (parseInt(answers[0]) >= parseInt(rule1[2])) {
                      console.log(answers[0] + " " + rule1[2]);
                      found = true;
                      if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                        this.showAnomalyRepeater = true;
                        this.repeaterAnomalyHeading = anomaly.Msg_H;
                        this.repeaterAnomalyMsg = anomaly.Msg;
                        this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                      } else {
                        this.showAnomaly = true;
                        this.simpleAnomalyHeading = anomaly.Msg_H;
                        this.simpleAnomalyMsg = anomaly.Msg;
                        this.simpleAnomalyMsg_S = anomaly.Msg_S;
                      }
                    }
                  }

                } else {

                  let ruleAnswers = rule1[2].substring(1, rule1[2].length - 1).split(",");


                  console.log(ruleAnswers);
                  console.log(answers);

                  for (let answer of answers) {

                    let foundMatch: boolean = false;

                    if (!isNaN(parseInt(answer))) {

                      for (let ruleAnswer of ruleAnswers) {

                        if (!isNaN(parseInt(ruleAnswer)) && parseInt(ruleAnswer) === parseInt(answer)) {

                          console.log(ruleAnswer + " " + answer);
                          found = true;
                          foundMatch = true;
                          if (this.questions[question_Num - 1].Parent_Repeat !== null) {
                            this.showAnomalyRepeater = true;
                            this.repeaterAnomalyHeading = anomaly.Msg_H;
                            this.repeaterAnomalyMsg = anomaly.Msg;
                            this.repeaterAnomalyMsg_S = anomaly.Msg_S;
                          } else {
                            this.showAnomaly = true;
                            this.simpleAnomalyHeading = anomaly.Msg_H;
                            this.simpleAnomalyMsg = anomaly.Msg;
                            this.simpleAnomalyMsg_S = anomaly.Msg_S;
                          }
                          break;
                        }

                      }

                      if (foundMatch) {
                        break;
                      }

                    }


                  }

                }


              }


            }


          }


          if (found) {
            break;
          }
        }
      }


  }


  shouldIShowRepeaterQuestion(question : Questions, index : number) : boolean{



    if(question.Opt_Dep.length > 0){

      if(this.questions[question.Parent_Dep -1].user_Res[index].length > 0){
        let answers = this.questions[question.Parent_Dep -1].user_Res[index].split(" ");
        for(let answer of answers){

          for(let option of question.Opt_Dep){

            if(!isNaN(parseInt(answer)) && parseInt(answer) === option){

              if(parseInt((question.Age_Range.length).toString())==parseInt('0') && this.repeater2dArray[index][question.Parent_Dep - this.repeaterQuestion.Qn_Num-1].is_Visible){

                question.is_Visible = true;

                return true;

              }

              else {

                if(!this.repeater2dArray[index][question.Parent_Dep - this.repeaterQuestion.Qn_Num-1].is_Visible){

                  question.is_Visible = false;

                  return false;

                }

                else{




                    if(this.questions[question.Parent_Age -1].user_Res[index].length === 0){

                      question.is_Visible = false;

                      return false;

                    }else{

                      if(question.Age_Range[0] <= parseInt(this.questions[question.Parent_Age -1].user_Res[index]) && question.Age_Range[1] >= parseInt(this.questions[question.Parent_Age -1].user_Res[index])){

                        question.is_Visible = true;

                        return true;

                      }else{

                        question.is_Visible = false;

                        return false;

                      }

                    }
                }
              }
            }
          }
        }
      }
      question.is_Visible = false;
      return false;
    }

    if(parseInt((question.Age_Range.length).toString())==parseInt('0')){

      question.is_Visible = true;
      return true;
    }
    else {

      if(!this.repeater2dArray[index][question.Parent_Age - this.repeaterQuestion.Qn_Num-1].is_Visible){

        question.is_Visible = false;
        return false;
      }else{



          if(this.questions[question.Parent_Age -1].user_Res[index].length === 0){

            question.is_Visible = false;
            return false;
          }else{

            if(question.Age_Range[0] <= parseInt(this.questions[question.Parent_Age -1].user_Res[index]) && question.Age_Range[1] >= parseInt(this.questions[question.Parent_Age -1].user_Res[index])){

              question.is_Visible = true;
              return true;
            }else{
              question.is_Visible = false;
              return false;
            }



        }

      }

    }
  }




  userEnteredValueInRepeater(userRes){


    this.indexOfRepeater  = parseInt(userRes[4]);


    if(!this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res){
      this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res  = [1];
      this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.pop()
    }

    switch(userRes[0]){
      case "checkbox":{

        if(userRes[3] === 'true'){

          this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.push(parseInt(userRes[2]));
        }else{


          let index : number = this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.indexOf(parseInt(userRes[2]));


          if(index > -1){
            this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.splice(index,1);
          }
        }

        break;

      }
      case "radio":{

        this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.splice(0,this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.length);

        this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.push(parseInt(userRes[2]));


        break;

      }

      case "dropdown":{

        this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.splice(0,this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.length);

        this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.push(parseInt(userRes[2]));

        break;

      }
      case "natural":{



        this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.splice(0,this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.length);

        this.repeater2dArray[this.indexOfRepeater][parseInt(userRes[1])-this.repeaterQuestion.Qn_Num-1].user_Res.push(parseInt(userRes[2]));

        break;

      }

    }

  }



//Dialog boc to call for repeater question
  repeaterDialogBoxOpen(repeaterQuestion : Questions){


    if(!repeaterQuestion.user_Res || parseInt(repeaterQuestion.user_Res[0]) === 0 || isNaN(parseInt(repeaterQuestion.user_Res[0])) || parseInt(repeaterQuestion.user_Res[0]) === -1 || repeaterQuestion.user_Res[0] === null ){
      return;
    }


    this.repeaterQuestionDeps.splice(0,this.repeaterQuestionDeps.length);
    this.indexArray.splice(0,this.indexArray.length);
    this.repeater2dArray.splice(0,this.repeater2dArray.length);
    this.tabs.splice(0,this.tabs.length);


    for ( let questionNumber of repeaterQuestion.Qn_Repeat){
      this.repeaterQuestionDeps.push(this.questions[questionNumber-1]);
    }

    this.repeaterQuestion = repeaterQuestion;
    this.numOfRepeater = parseInt(repeaterQuestion.user_Res[0]);

    for (let i : number = 0 ; i < this.numOfRepeater ; i = i +1 ){


      this.repeater2dArray[i] = JSON.parse(JSON.stringify(this.repeaterQuestionDeps));
      this.indexArray.push(i);
      this.tabs.push("Entry"+i);

      if(i > 0){

        for(let j=0;j<repeaterQuestion.Qn_Repeat.length;j++){

          this.questions[repeaterQuestion.Qn_Repeat[j] - 1].user_Res.push("");

        }

      }

    }



    this.shouldIShowRepeaterDialogBox = ".shouldIShowRepeaterDialogBox";

    this.broadcastEventService.setQuestions(this.questions);
    localStorage.setItem("test123",JSON.stringify(this.questions));

  }

  repeaterDialogBoxClosed(){
    this.shouldIShowRepeaterDialogBox = "";
    this.showAnomalyRepeater = false;
    this.i = 0;
 }


  showPreviewClicked(){
    if(this.previewToggleLabel === 'Preview'){
      this.previewToggleLabel = 'Close';
    }else{
      this.previewToggleLabel = 'Preview';
    }
    this.showPreview.emit('');
  }


  trackByFn(index, item) {

    return item.user_Res;
  }

  dismissAnomalyRepeater(){
    this.showAnomalyRepeater = false;
  }

  dismissAnomaly(){
    this.showAnomaly = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/questionnairePreview/questionnaire-preview.component.ts